// import $ from 'jquery/src/jquery';
import './index.scss'
import {isGutenbergEditorVisible} from "../../src/scripts/helpers";

function init(scope = document) {
    

    const nodeSelectors = {
        container: '[js-video-gallery-slider="container"]',
        slider: '[js-video-gallery-slider="slider"]',
        pagination: '[js-video-gallery-slider="pagination"]',
        prev: '[js-video-gallery-slider="prev"]',
        next: '[js-video-gallery-slider="next"]',
        play: '[js-video-gallery-slider="play-button"]',
        close: '[js-video-gallery-slider="close"]',
    }

    const containers = scope.querySelectorAll(nodeSelectors.container);

    if (!containers.length) return;

    containers.forEach(container => {
        const sliderEl = container.querySelector(nodeSelectors.slider);
        if (!sliderEl) return;

        // Destroy existing swiper instance before re-init
        if (sliderEl.swiper) {
            sliderEl.swiper.destroy(true, true);
        }

        const settings = {
            slidesPerView: 4,
            spaceBetween: 15,
            speed: 500,
            autoplay: {
                delay: 2500
            },
            navigation: {
                nextEl: container.querySelector(nodeSelectors.next),
                prevEl: container.querySelector(nodeSelectors.prev),
            },
            pagination: {
                el: container.querySelector(nodeSelectors.pagination),
                clickable: true
            },
            breakpoints: {
                300: {
                    slidesPerView: 1,
                },
                // when window width is >= 480px
                768: {
                    slidesPerView: 3
                },
                // when window width is >= 640px
                1024: {
                    slidesPerView: 4
                }
            }
        };

        new Swiper(sliderEl, settings);

        jQuery(nodeSelectors.play).on('click', function(){
            let currentVideo = jQuery(this).data('video');
            jQuery('.video-popup').fadeIn();
            jQuery('.video-popup iframe').attr('src', 'https://www.youtube.com/embed/'+currentVideo+'?autoplay=1')
        })

        jQuery('.video-popup').on('click', function (event) {
            const clickedOutsideIframe = jQuery(event.target).closest('.iframe-holder').length === 0;

            if (clickedOutsideIframe) {
                jQuery('.video-popup').fadeOut();
                jQuery('.video-popup iframe').attr('src', '');
            }
        });
    })
}

document.addEventListener('DOMContentLoaded', () => {
    if ( window.acf ) {
        // Only in block editor preview
        window.acf.addAction('render_block_preview/type=featured-videos', ($block) => {
            const blockEl = $block[0] || $block;
            init(blockEl);
        });
    } else if( !isGutenbergEditorVisible() ) {
        // Only in frontend
        init()
    }
});